var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "base-switch" }, [
    _c(
      "div",
      { staticClass: "base-switch__list" },
      _vm._l(_vm.options, function (option, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "base-switch__item",
            class: {
              "is-active": option === _vm.value,
              "is-male": option === "M",
              "is-female": option === "F",
            },
            on: {
              click: function ($event) {
                return _vm.handleChange(option)
              },
            },
          },
          [
            _c("div", { staticClass: "base-switch__control" }, [
              option === "M"
                ? _c("span", { staticClass: "base-switch__label" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M11 10C11 7.23801 8.761 5 6 5C3.239 5 1 7.23801 1 10C1 12.761 3.239 15.0001 6 15.0001C8.761 15.0001 11 12.761 11 10Z",
                            stroke: "#1A5DD0",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M15 1L10 6.00003",
                            stroke: "#1A5DD0",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M11 1H15V5.00002",
                            stroke: "#1A5DD0",
                            "stroke-width": "2",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              option === "F"
                ? _c("span", { staticClass: "base-switch__label" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M5 6C5 8.761 7.239 11 10 11C12.762 11 15 8.761 15 6C15 3.238 12.762 1 10 1C7.239 1 5 3.238 5 6Z",
                            stroke: "#BA5BD3",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M1 15L6 10",
                            stroke: "#BA5BD3",
                            "stroke-width": "2",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M1 11L5 15",
                            stroke: "#BA5BD3",
                            "stroke-width": "2",
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }